<template>
  <section id="team">
    <div class="team-wrapper">
      <h2 id="our-team"><a href="#our-team" class="header-link">Our Current Team</a></h2>
      <section id="leaders" class="icon-tile">
        <h3 id="leadership"><a href="#leadership" class="header-link">Leadership</a></h3>
        <div class="icon-display">
          <LeaderTile v-for="(leader, index) in leaders" :key="index" :data="leader"/>
        </div>
      </section>
      <section id="advisors" class="icon-tile">
        <h3 id="advisors-mentors"><a href="#advisors-mentors" class="header-link">Advisors & Mentors</a></h3>
        <div class="icon-display">
          <LeaderTile v-for="(advisor, index) in advisors" :key="index" :data="advisor"/>
        </div>
      </section>
      <section id="members">
        <h3 id="members-list"><a href="#members-list" class="header-link">Members</a></h3>
        <p><i>A full list of all past and present members can be found on <a :href="$store.state.general.membersSpreadsheet" target="_blank">this spreadsheet</a>.</i></p>
        <div class="list-display">
          <MemberTile v-for="(member, index) in members" :key="index" :data="member"/>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import LeaderTile from "@/components/LeaderTile.vue";
import MemberTile from "@/components/MemberTile.vue";

export default {
  name: "TeamView",
  components: {
    LeaderTile,
    MemberTile,
  },
  computed: {
    leaders() {
      return this.$store.state.leaders;
    },
    advisors() {
      return this.$store.state.advisors;
    },
    members() {
      return this.$store.state.members;
    }
  },
}
</script>

<style lang="scss">
.team-wrapper {
  position: relative;
  background-color: var(--white);
  padding: var(--section-padding);
  padding-top: 1em;
  padding-bottom: 1em;
  height: 100%;

  p {
    a {
      color: var(--medium);
      text-decoration: underline;
      font-weight: bold;
    }

  }

  .icon-tile {
    max-width: var(--max-width);
    margin: auto;
    align-items: self-start;

    .icon-display {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      align-items: flex-start;
      row-gap: 0;
      column-gap: 3em;
    }
  }

  #members {
    .list-display {
      column-width: 12em;
      column-gap: 2em;
    }
  }
}

@media screen and (max-width: 768px) {
  .team-wrapper {
    padding: 2rem var(--section-padding-mobile, 6%) 1.5rem;

    .icon-tile {
      margin-bottom: 1.5rem;

      .icon-display {
        gap: 1.25rem 0.75rem;
      }
    }

    #members {
      p {
        font-size: 0.85rem;
        line-height: 1.35;
        margin-bottom: 0.75rem;
      }

      .list-display {
        column-width: 8.5em;
        column-gap: 1rem;
      }
    }
  }
}
</style>
